module.exports = "<svg id=\"471da782-e7bd-4708-a642-e0e01815be61\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>difference-no-goopy</title><path d=\"M24.83.5A24.33,24.33,0,1,0,49.17,24.83,24.33,24.33,0,0,0,24.83.5ZM31,15.29a2.86,2.86,0,1,1-2.86,2.86h0A2.87,2.87,0,0,1,31,15.29Zm-12.41,0a2.86,2.86,0,1,1-2.86,2.86,2.86,2.86,0,0,1,2.86-2.86h0ZM37,33a12.36,12.36,0,0,1-24.33,0l-.1-.56H37.09Z\" style=\"fill:#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/difference-no-goopy.svg
// module id = 532
// module chunks = 1